import { Collapse } from "antd";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useState } from "react";

import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { MAPPING_LEVELS } from "../requirements/constants";
import { MappingsTable } from "../requirements/mappingsTab/table";
import RequirementContext from "../requirements/context";
import { AddRequirementMappingDialog } from "@src/appV2/RequirementMapping/AddRequirementMappingDialog";

const { Panel } = Collapse;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'hcfId' implicitly has an 'any' type.
function HcfRequirement({ hcfId }) {
  const [mappingToEdit, setMappingToEdit] = useState(null);
  const [mappingToAdd, setMappingToAdd] = useState(null);
  const [filter, setFilter] = useState([
    MAPPING_LEVELS.GLOBAL,
    MAPPING_LEVELS.LOCATION,
    MAPPING_LEVELS.HCF,
  ]);
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { adminProfile } = useSelector((state: any) => state.session || {});

  const allowedDocRoles = new RegExp(
    `(${EMPLOYEE_ROLES.DOCUMENTS}|${EMPLOYEE_ROLES.DOCUMENT_CREATION})`
  );
  if (!allowedDocRoles.test(adminProfile.roles.join(" "))) {
    return null;
  }

  const context = {
    filter,
    setFilter,
    mappingToEdit,
    setMappingToEdit,
    mappingToAdd,
    setMappingToAdd,
  };

  return (
    <RequirementContext.Provider value={context}>
      <Collapse>
        <Panel header="Document Mappings" key="Document Mappings">
          <AddRequirementMappingDialog hcfId={hcfId} />
          <MappingsTable hcfId={hcfId} />
        </Panel>
      </Collapse>
    </RequirementContext.Provider>
  );
}

HcfRequirement.propTypes = {
  hcfId: PropTypes.string.isRequired,
};

export { HcfRequirement };
